export const formDataSources = [
    {
        key: 'consultation_types',
        label: 'Consultation Types',
        source: 'Query',
        endpoint: 'consultationTypes',
        labelProperty: 'name',
        valueProperty: '_id',
        supportsTypes: ['Select', 'Multi Select'],
    },
    {
        key: 'previous_values',
        label: 'Previous Values',
        source: 'Previous',
        endpoint: 'previousValues',
        supportsTypes: ['Select', 'Multi Select'],
        requiresPayload: true,
    },
    {
        key: 'icd11_diagnoses',
        label: 'ICD-11 Diagnoses',
        source: 'Query',
        supportsTypes: ['Select', 'Multi Select'],
        special: 'icd11',
    },
]

const legacyEndpointToKey = {
    consultationTypes: 'consultation_types',
    previousValues: 'previous_values',
    diagnoses: 'icd11_diagnoses',
}

export const getFormDataSource = key => formDataSources.find(source => source.key === key)

export const inferFieldDataSourceKey = field => {
    if (field?.dataSourceKey)
        return field.dataSourceKey

    if (field?.endpoint && legacyEndpointToKey[field.endpoint])
        return legacyEndpointToKey[field.endpoint]

    if (['SearchableFromPrevious', 'MultiSearchableFromPrevious'].includes(field?.type))
        return 'previous_values'

    return undefined
}

export const getAvailableDataSources = typeLabel => formDataSources
    .filter(source => source.supportsTypes.includes(typeLabel))
    .map(source => ({ label: source.label, value: source.key }))

export const getFieldSourceLabel = field => {
    const key = inferFieldDataSourceKey(field)
    const source = getFormDataSource(key)

    return source?.source ?? (field?.type?.includes('Searchable') ? 'Query' : 'List')
}

export const getPreviousValuePayload = (field = {}) => {
    const payload = field?.payload ?? {}

    return {
        field: payload?.field ?? field?.name ?? '',
        categories: Array.isArray(payload?.categories) ? payload.categories : [],
        item: payload?.item,
    }
}

export const buildFormFieldPayload = (field = {}) => {
    const typeLabel = field?.type?.label ?? field?.type
    const sourceLabel = field?.source?.label ?? field?.source
    const dataSourceKey = inferFieldDataSourceKey(field)
    const dataSource = getFormDataSource(dataSourceKey)
    const isSelect = typeLabel === 'Select' || typeLabel === 'Multi Select'
    const multi = typeLabel === 'Multi Select'

    let type = typeLabel
    if (isSelect) {
        if (sourceLabel === 'Previous')
            type = `${multi ? 'Multi' : ''}SearchableFromPrevious`
        else if (sourceLabel === 'Query')
            type = `${multi ? 'Multi' : ''}SearchableSelect`
        else if (field?.creatable)
            type = 'CreatableSelect'
    }

    return {
        name: field?.name,
        unit: field?.unit,
        type,
        dataSourceKey: dataSource?.key,
        labelProperty: dataSource?.labelProperty ?? field?.labelProperty,
        valueProperty: dataSource?.valueProperty ?? field?.valueProperty,
        endpoint: dataSource?.endpoint,
        createEndpoint: undefined,
        options: (field?.options ?? []).map(option => option?.label ?? option).filter(Boolean),
        payload: dataSource?.requiresPayload ? getPreviousValuePayload(field) : undefined,
    }
}
